import { all } from 'redux-saga/effects';
import effects from 'modules/sagas';
// -------

const RootEffects = function* rootEffects() {
  return yield all([...effects]);
};

export default RootEffects;
